import { SHA256 } from 'crypto-js';

import { isValidEmail } from './utils.validation';

export const hashEmailSHA256 = (email: string): string | null => {
  if (!isValidEmail(email)) {
    return null;
  }

  try {
    const normalizedEmail = email.trim().toLowerCase();
    const hash = SHA256(normalizedEmail);

    return hash.toString();
  } catch (error) {
    console.warn('Error in sync email hashing:', error);
    return null;
  }
};
